import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

export const SvgPenaltySaveDimension = {
  height: 20,
  width: 20,
  viewBox: '0 0 16 16',
};

export const SvgPenaltySave = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path fill="currentColor" d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0" />
      <path
        fill="#fff"
        d="M8.46 7.48V4.11A.452.452 0 0 0 8 3.67a.453.453 0 0 0-.46.44v3.37a.333.333 0 0 1-.667 0V4.63a.453.453 0 0 0-.46-.445.453.453 0 0 0-.46.445v4.408a.333.333 0 0 1-.667 0v-1.296a.453.453 0 0 0-.46-.445.453.453 0 0 0-.46.445v1.038c0 1.957 1.62 3.555 3.634 3.555s3.634-1.598 3.634-3.555V6.184a.453.453 0 0 0-.46-.444.453.453 0 0 0-.46.444V7.48a.333.333 0 0 1-.667 0V4.63a.452.452 0 0 0-.46-.445.453.453 0 0 0-.46.445v2.852a.333.333 0 0 1-.667 0m2.253-2.31c.142-.062.297-.098.461-.098.616 0 1.126.49 1.126 1.11V8.78c0 2.338-1.931 4.222-4.3 4.222s-4.3-1.884-4.3-4.222V7.742c0-.618.511-1.112 1.126-1.112.163.001.318.036.46.099V4.63c0-.618.511-1.112 1.127-1.112.2 0 .39.054.554.146A1.13 1.13 0 0 1 8 3c.457 0 .856.27 1.032.664.164-.093.354-.146.555-.146.616 0 1.126.491 1.126 1.112z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
      <filter
        id="d"
        width={28.571}
        height={28.571}
        x={-4.286}
        y={-3.571}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.714} />
        <feGaussianBlur stdDeviation={2.143} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8035_11266" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_8035_11266" result="shape" />
      </filter>
    </defs>
  </svg>
));
